export class DiseaseFilterSettingsModel {
  public diseaseName: string;
  public diseaseCode: string;
  public alphaIndex: string;
}